import { MediaFeedType } from '@optools/services/operator-gateway/types/generated/graphql';
import { z } from 'zod';

export const pipelineParamsSchema = z.object({
  feedType: z.enum(MediaFeedType),
});

export const pipelineSearchSchema = z.object({
  asset: z.string().optional().default(''),
  mediaId: z.string().optional().default(''),
});
